module.exports = __webpack_public_path__ + "static/img/b920e151fa96606bd0f047c56078b84b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/btn.png
// module id = Ji48
// module chunks = 1